"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_SHAREABLE_DESIGN_EVENTS = void 0;
var ACCESS_SHAREABLE_DESIGN_EVENTS;
(function (ACCESS_SHAREABLE_DESIGN_EVENTS) {
    ACCESS_SHAREABLE_DESIGN_EVENTS["ACCESS_SHAREABLE_DESIGN"] = "ACCESS_SHAREABLE_DESIGN";
    ACCESS_SHAREABLE_DESIGN_EVENTS["ACCESS_SHAREABLE_DESIGN_SUCCESS"] = "ACCESS_SHAREABLE_DESIGN_SUCCESS";
    ACCESS_SHAREABLE_DESIGN_EVENTS["ACCESS_SHAREABLE_DESIGN_ERROR"] = "ACCESS_SHAREABLE_DESIGN_ERROR";
})(ACCESS_SHAREABLE_DESIGN_EVENTS || (exports.ACCESS_SHAREABLE_DESIGN_EVENTS = ACCESS_SHAREABLE_DESIGN_EVENTS = {}));
